import {FieldMap, FieldOperations, OpsCategories, SqlOperation, TableI} from "../Types";
import {nanoid} from "@reduxjs/toolkit";
import {GREEN_COLOR, GREEN_LIGHT_COLOR, RED_COLOR, SELECT_BACK_COLOR, YELLOW_COLOR} from "../components/CONSTANTS";
import moment from "moment/moment";


let fieldOperations: FieldOperations = {
    barcode: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    id: [...OpsCategories.eq, ...OpsCategories.range, ...OpsCategories.in,],
    inmsg_id: [...OpsCategories.eq, ...OpsCategories.range, ...OpsCategories.in,],
};
export const CertificatesTable: TableI = {
    backend: "/343/",
    title: {
        ua: "Сертифікати",
    },
    pk: 'id',
    defaultOrderedBy: "id",
    defaultOrderedWay: "ASC",
    defaultPerPage: 20,
    orderByFields: {
        "id": {ua: "ID", en: "№"},
    },
    fieldOperations: fieldOperations,
    defaultFilters: 'certificates343DefFilters',
    action: "certificates343SendCertificate",
    fields: [
        {
            key: "n",
            inline: true,
            title: {ua: "№"}, type: "number",
            applyTransform: true
        },
        {
            key: "id",
            detailed: true,
            title: {ua: "ID"},
            type: "number",
            applyTransform: true
        },
        {
            key: "barcode",
            type: 'string',
            applyTransform: true,
            detailed: true,
            inline: true,
            title: {ua: "barcode"}
        },
        {
            key: "facevalue",
            type: 'string',
            applyTransform: true,
            detailed: true,
            inline: true,
            title: {ua: "facevalue"}
        },
        {
            key: "expiredatefrom",
            type: 'date',
            applyTransform: true,
            datetimeFormat: "DD MMMM YYYY",
            detailed: true,
            inline: true,
            title: {ua: "expiredatefrom"}
        },{
            key: "expiredateto",
            type: 'date',
            applyTransform: true,
            datetimeFormat: "DD MMMM YYYY",
            detailed: true,
            inline: true,
            title: {ua: "expiredateto"}
        },
        {
            key: "pinecom",
            type: 'string',
            applyTransform: true,
            detailed: true,
            inline: true,
            title: {ua: "pinecom"}
        },
        {
            key: "inmsg_id",
            type: 'string',
            applyTransform: true,
            detailed: true,
            inline: true,
            title: {ua: "ID реєстрації"}
        },
        {
            key: "sent_dt",
            title: {ua: "Відправлено"},
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            detailed: true,
            inline: true,
        },
    ]
}

export function certificates343DefFilters() {
    return []
}

